import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/*
      <svg
        width={86}
        height={19}
        viewBox="0 0 86 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
			<defs>
				<style>.cls-1{fill:#231f20;}.cls-2{fill:#ffba50;}.cls-3{fill:#7cc05b;}.cls-4{fill:#8d7f89;}</style>
			</defs>

*/
export function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 60, width: 60 }}>
		<svg width="800px" height="800px" viewBox="0 0 50 50" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg">
			<title/>
			<path className="cls-1" d="M8.513,25.5h9.875a3.1,3.1,0,0,0,3.058,2.608h7.108A3.1,3.1,0,0,0,31.612,25.5h9.875A4.017,4.017,0,0,0,45.5,21.487V16.833a4.007,4.007,0,0,0-3.784-3.99,3.105,3.105,0,0,0-3.057-2.6H31.551A3.107,3.107,0,0,0,28.5,12.82H22.2V11.492a.5.5,0,0,0-.43-.5l-2.047-.289,1.243-1.65a.5.5,0,0,0-.045-.654L18.292,5.779a.5.5,0,0,0-.654-.046L15.987,6.977,15.7,4.93A.5.5,0,0,0,15.2,4.5H11.492a.5.5,0,0,0-.5.43l-.289,2.047L9.058,5.733a.5.5,0,0,0-.654.046L5.779,8.4a.5.5,0,0,0-.046.654l1.244,1.65L4.93,11a.5.5,0,0,0-.43.5V15.2a.5.5,0,0,0,.43.495l2.047.288L5.733,17.638a.5.5,0,0,0,.046.654L8.4,20.917a.5.5,0,0,0,.654.046l1.65-1.243L11,21.766a.5.5,0,0,0,.5.43H15.2a.5.5,0,0,0,.495-.43l.288-2.047,1.651,1.244a.5.5,0,0,0,.654-.046l2.625-2.625a.5.5,0,0,0,.045-.654l-1.243-1.651,2.047-.288a.5.5,0,0,0,.43-.495V13.82H28.49a3.1,3.1,0,0,0,3.061,2.636h7.108a3.1,3.1,0,0,0,3.058-2.613,3.008,3.008,0,0,1,2.783,2.99v4.654A3.017,3.017,0,0,1,41.487,24.5H31.612a3.1,3.1,0,0,0-3.058-2.608H21.446A3.1,3.1,0,0,0,18.388,24.5H8.513A4.017,4.017,0,0,0,4.5,28.513v4.654a4.007,4.007,0,0,0,3.784,3.99,3.105,3.105,0,0,0,3.057,2.6h7.108A3.107,3.107,0,0,0,21.5,37.18h6.142a8.958,8.958,0,1,0-.012-1H21.51a3.1,3.1,0,0,0-3.061-2.636H11.341a3.1,3.1,0,0,0-3.058,2.613A3.008,3.008,0,0,1,5.5,33.167V28.513A3.017,3.017,0,0,1,8.513,25.5Zm4.835-8.582a3.57,3.57,0,1,1,3.57-3.57A3.574,3.574,0,0,1,13.348,16.918Z"/>
			<path className="cls-2" d="M38.659,15.456H31.551a2.108,2.108,0,1,1,0-4.216h7.108a2.108,2.108,0,1,1,0,4.216Z"/>
			<path className="cls-2" d="M21.446,22.892h7.108a2.108,2.108,0,0,1,2.105,2.076c0,.011-.006.021-.006.032s.006.021.006.032a2.108,2.108,0,0,1-2.105,2.076H21.446a2.108,2.108,0,0,1-2.105-2.076c0-.011.006-.021.006-.032s-.006-.021-.006-.032A2.108,2.108,0,0,1,21.446,22.892Z"/>
			<path className="cls-2" d="M11.341,34.544h7.108a2.108,2.108,0,1,1,0,4.216H11.341a2.108,2.108,0,0,1,0-4.216Z"/>
			<circle className="cls-1" cx="22.482" cy="25" r="0.502"/><circle className="cls-1" cx="25.024" cy="25" r="0.502"/>
			<circle className="cls-1" cx="27.518" cy="25" r="0.502"/><circle className="cls-1" cx="32.587" cy="13.348" r="0.502"/>
			<circle className="cls-1" cx="35.129" cy="13.348" r="0.502"/><circle className="cls-1" cx="37.622" cy="13.348" r="0.502"/>
			<circle className="cls-1" cx="17.413" cy="36.652" r="0.502"/><circle className="cls-1" cx="14.871" cy="36.652" r="0.502"/>
			<circle className="cls-1" cx="12.378" cy="36.652" r="0.502"/>
			<path className="cls-3" d="M36.557,28.615a7.943,7.943,0,1,1-7.942,7.942A7.952,7.952,0,0,1,36.557,28.615Z"/>
			<path className="cls-4" d="M18.74,15.115,21.2,14.77V11.927l-2.456-.346a.5.5,0,0,1-.33-.8L19.9,8.8l-2.01-2.011L15.911,8.286a.5.5,0,0,1-.8-.33L14.77,5.5H11.926l-.345,2.456a.5.5,0,0,1-.8.33L8.8,6.793,6.793,8.8l1.493,1.981a.5.5,0,0,1-.33.8L5.5,11.927V14.77l2.456.345a.5.5,0,0,1,.33.8L6.793,17.892,8.8,19.9l1.981-1.493a.5.5,0,0,1,.8.33l.345,2.456H14.77l.345-2.456a.5.5,0,0,1,.8-.33L17.892,19.9l2.01-2.011L18.41,15.911a.5.5,0,0,1,.33-.8Zm-5.392,1.8a3.57,3.57,0,1,1,3.57-3.57A3.574,3.574,0,0,1,13.348,16.918Z"/>
			<path className="cls-1" d="M13.348,8.778a4.57,4.57,0,1,0,4.57,4.57A4.575,4.575,0,0,0,13.348,8.778Zm0,8.14a3.57,3.57,0,1,1,3.57-3.57A3.574,3.574,0,0,1,13.348,16.918Z"/>
			<path className="cls-1" d="M35.751,38.763a.5.5,0,0,0,.707,0l4.124-4.124a.5.5,0,0,0-.707-.707L36.1,37.7,34.272,35.87a.5.5,0,0,0-.707.707Z"/>
		</svg>
    </SvgIcon>
  );
}

export function FacebookIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.68 15.92C2.88 15.24 0 11.96 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 11.96 13.12 15.24 9.32 15.92L8.88 15.56H7.12L6.68 15.92Z"
          fill="url(#paint0_linear_795_116)"
        />
        <path
          d="M11.12 10.2391L11.48 7.99914H9.36V6.43914C9.36 5.79914 9.6 5.31914 10.56 5.31914H11.6V3.27914C11.04 3.19914 10.4 3.11914 9.84 3.11914C8 3.11914 6.72 4.23914 6.72 6.23914V7.99914H4.72V10.2391H6.72V15.8791C7.16 15.9591 7.6 15.9991 8.04 15.9991C8.48 15.9991 8.92 15.9591 9.36 15.8791V10.2391H11.12Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_795_116"
            x1="8"
            y1="0"
            x2="8"
            y2="15.9991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1AAFFF" />
            <stop offset="1" stopColor="#0163E0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GoogleIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54545H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z"
          fill="#4285F4"
        />
        <path
          d="M8 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98545 12.5309 9.07636 12.8218 8 12.8218C5.92 12.8218 4.15273 11.4182 3.52 9.52727H0.858182V11.5927C2.17455 14.2036 4.87273 16 8 16Z"
          fill="#34A853"
        />
        <path
          d="M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.46909 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70545 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z"
          fill="#FBBC05"
        />
        <path
          d="M8 3.18545C9.17818 3.18545 10.2255 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 8 0C4.87273 0 2.17455 1.79636 0.858182 4.41455L3.52 6.48C4.15273 4.58909 5.92 3.18545 8 3.18545Z"
          fill="#EA4335"
        />
      </svg>
    </SvgIcon>
  );
}
